export default __webpack_public_path__ + "static/media/raiffeisen_background_m1.a6a658bf.jpg";